const enum UserActions {
    INIT = 'INIT',
    LOG_IN = 'LOG_IN',
    LOG_OUT = 'LOG_OUT',
    SET_USER_INFO = 'SET_USER_INFO',
    SET_DEALER = 'SET_DEALER',
    CANCEL_LOG_IN = 'CANCEL_LOG_IN',
    SET_BUSINESS_UNIT = 'SET_BUSINESS_UNIT',
    SET_BUSINESS_UNIT_BRAND = 'SET_BUSINESS_UNIT_BRAND',
    RESET_SESSION = 'RESET_SESSION',
}

interface Payload {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
}
export interface UserAction {
    type: UserActions
    payload?: Payload
}

export default UserActions
